<template>
  <div class="md:flex md:flex-grow">
    <div class="flex flex-col flex-grow overflow-scroll bg-gray-100">
      <div
        id="home-hero"
        class="relative text-white bg-gray-500 flex-grow flex flex-col justify-center text-center items-center h-64 p-8 py-56 md:py-8 bg-cover bg-center flex-3"
        :style="imageHome"
      >
        <h1 class="text-3xl md:text-5xl leading-none">Welcome to the the Marine Stores Guide</h1>
        <p class="mt-8 text-lg md:text-xl px-3 py-1 border rounded-lg">Tip: Press tab to jump to the search box</p>
      </div>
      <div id="home-features" class="flex w-full flex-col md:flex-row">
        <HomeFeature label="Browse" :image="imageBrowse" link="products" />
        <HomeFeature label="Help & Support" :image="imageHelp" link="page/help" />
        <HomeFeature label="Advertising" :image="imageAdvertise" link="page/advertise" />
      </div>
    </div>
    <iframe src="/advert/sidebar" frameborder="0" class="bg-gray-10 p-6 w-64 bg-gray-200"></iframe>
  </div>
</template>

<script>
  import HomeFeature from '../components/HomeFeature'
	export default {
    components: {HomeFeature},
    name: 'home',
    data() {
      return {
        imageHome: 'background-image: url(' + appData.imageHome + ')',
        imageBrowse: appData.imageBrowse,
        imageHelp:appData.imageHelp,
        imageAdvertise:appData.imageAdvertise
      }
    }
	}
</script>

<style>

</style>